import React from "react";
import { DialogWindow } from "./DialogWindow";
import { Box, Button, Stack, Typography } from "@mui/material";

export const WarningWindow = ({
  title,
  content,
  handleClose,
  handleButtonClick = null,
  withoutActions = false,
}) => (
  <DialogWindow
    title={
      <Typography sx={{ fontWeight: "bold", fontSize: "1.1em" }}>
        {title}
      </Typography>
    }
    content={
      <Box mt={2} mb={2}>
        {content}
      </Box>
    }
    handleClose={handleClose}
    withCloseButton
    actions={
      !withoutActions ? (
        <Stack justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <Button
            variant="contained"
            onClick={handleButtonClick ?? handleClose}
          >
            Got it
          </Button>
        </Stack>
      ) : null
    }
  />
);
